// extracted by mini-css-extract-plugin
export default {"container":"PreorderView_container__uREz5"};